import { Alert, Button, Space } from 'antd'

type TilledAccountResolutionErrorProps = {
  hasSavedPaymentMethod: boolean
  onRetry: () => void
  onUseAnotherPaymentMethod?: () => void
}

export const TilledAccountResolutionError = ({
  hasSavedPaymentMethod,
  onRetry,
  onUseAnotherPaymentMethod,
}: TilledAccountResolutionErrorProps) => (
  <Alert
    type="error"
    showIcon
    message={hasSavedPaymentMethod ? 'This saved payment method must be entered again' : 'Payment account unavailable'}
    description={
      hasSavedPaymentMethod
        ? 'For your security, enter a new payment method or choose another way to pay.'
        : 'We could not safely load the payment account. Try again before submitting a payment.'
    }
    action={
      <Space direction="vertical">
        {onUseAnotherPaymentMethod && <Button onClick={onUseAnotherPaymentMethod}>Use another payment method</Button>}
        <Button onClick={onRetry}>Try again</Button>
      </Space>
    }
  />
)

export const TilledAccountResolutionStatus = ({
  isLoading,
  hasError,
  onRetry,
}: {
  isLoading: boolean
  hasError: boolean
  onRetry: () => void
}) => {
  if (isLoading) {
    return (
      <Alert
        className="mb-4"
        type="info"
        showIcon
        message="Loading payment account"
        description="Card, ACH, and payment-link options will be available when the account is ready."
      />
    )
  }

  if (hasError) {
    return (
      <div className="mb-4">
        <TilledAccountResolutionError hasSavedPaymentMethod={false} onRetry={onRetry} />
      </div>
    )
  }

  return null
}
